import React from 'react';
import { useIntl } from 'react-intl';
import Link from 'next/link';

import Icon from '../../../../../../../atoms/icons/Icon';

import css from './GoogleCalendarTemplateUrl.module.scss';

interface Props {
  googleCalendarTemplateUrl: string;
}

const GoogleCalendarTemplateUrl = ({ googleCalendarTemplateUrl }: Props) => {
  const intl = useIntl();
  return (
    <Link
      href={googleCalendarTemplateUrl}
      prefetch={false}
      className={css.GoogleCalendarTemplateUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon name="calendar" className={css.GoogleCalendarTemplateUrl__Icon} />
      <span className={css.GoogleCalendarTemplateUrl__Text}>
        {intl.formatMessage({
          id: 'books.booksMenu.googleCalendarTemplateUrl',
        })}
      </span>
    </Link>
  );
};

export default GoogleCalendarTemplateUrl;
